// modules
import { addModal } from 'weblite-web-modal-viewer'
// component
import { HashtagMenu } from './hashtag-menu'

const COMPONENT_ID = 'hashtagMenu'

interface Prop {
  hashtag: string
}

export const showHashtagMenu = ({ hashtag }: Prop, preventBackClick = false) =>
  addModal({
    id: COMPONENT_ID,
    props: { hashtag },
    preventBackClick,
  })

export default {
  [COMPONENT_ID]: { Component: HashtagMenu },
}
